import React from 'react';
import { Package, Truck, Globe, RefreshCw } from 'lucide-react';

const Shipping = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-16">
      <h1 className="text-3xl font-medium tracking-wide mb-8">SHIPPING & RETURNS</h1>
      
      <div className="space-y-8">
        {/* Shipping */}
        <div>
          <div className="flex items-center gap-3 mb-4">
            <Truck size={24} />
            <h2 className="text-xl font-medium">Shipping Information</h2>
          </div>
          <div className="space-y-4 text-gray-700">
            <div>
              <h3 className="font-medium mb-2 text-black">Free Standard Shipping</h3>
              <p className="text-sm">Free shipping on all orders over $200 within the United States. Orders typically arrive within 5-7 business days.</p>
            </div>
            <div>
              <h3 className="font-medium mb-2 text-black">Express Shipping</h3>
              <p className="text-sm">$15 - Delivery within 2-3 business days</p>
            </div>
            <div>
              <h3 className="font-medium mb-2 text-black">Next Day Delivery</h3>
              <p className="text-sm">$25 - Order by 2pm EST for next day delivery (Monday-Friday only)</p>
            </div>
          </div>
        </div>

        {/* International Shipping */}
        <div>
          <div className="flex items-center gap-3 mb-4">
            <Globe size={24} />
            <h2 className="text-xl font-medium">International Shipping</h2>
          </div>
          <div className="space-y-2 text-gray-700 text-sm">
            <p>We ship worldwide! International shipping costs are calculated at checkout based on your location.</p>
            <p>Delivery times vary by destination:</p>
            <ul className="list-disc list-inside ml-4 space-y-1">
              <li>Canada: 7-10 business days</li>
              <li>Europe: 10-14 business days</li>
              <li>Asia: 12-16 business days</li>
              <li>Rest of World: 14-21 business days</li>
            </ul>
            <p className="mt-3">Note: International orders may be subject to import duties and taxes, which are the responsibility of the customer.</p>
          </div>
        </div>

        {/* Order Processing */}
        <div>
          <div className="flex items-center gap-3 mb-4">
            <Package size={24} />
            <h2 className="text-xl font-medium">Order Processing</h2>
          </div>
          <div className="text-gray-700 text-sm space-y-2">
            <p>All orders are processed within 1-2 business days. Orders are not shipped or delivered on weekends or holidays.</p>
            <p>You will receive a shipping confirmation email with tracking information once your order has been dispatched.</p>
          </div>
        </div>

        {/* Returns */}
        <div>
          <div className="flex items-center gap-3 mb-4">
            <RefreshCw size={24} />
            <h2 className="text-xl font-medium">Returns & Exchanges</h2>
          </div>
          <div className="space-y-4 text-gray-700 text-sm">
            <div>
              <h3 className="font-medium mb-2 text-black">30-Day Return Policy</h3>
              <p>We accept returns within 30 days of delivery for a full refund. Items must be unworn, unwashed, and in original condition with all tags attached.</p>
            </div>
            <div>
              <h3 className="font-medium mb-2 text-black">How to Return</h3>
              <ol className="list-decimal list-inside ml-4 space-y-1">
                <li>Contact our customer service team at returns@ditris.com</li>
                <li>Receive your return authorization and shipping label</li>
                <li>Pack your items securely with the original packaging</li>
                <li>Ship your return using the provided label</li>
                <li>Receive your refund within 5-7 business days of return receipt</li>
              </ol>
            </div>
            <div>
              <h3 className="font-medium mb-2 text-black">Exchanges</h3>
              <p>We're happy to exchange items for a different size or color. Contact us at support@ditris.com to arrange an exchange.</p>
            </div>
            <div>
              <h3 className="font-medium mb-2 text-black">Non-Returnable Items</h3>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>Final sale items</li>
                <li>Gift cards</li>
                <li>Items damaged or altered after delivery</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Contact */}
        <div className="bg-gray-50 p-6 rounded">
          <h3 className="font-medium mb-2">Need Help?</h3>
          <p className="text-sm text-gray-600 mb-3">
            Our customer service team is here to help with any shipping or return questions.
          </p>
          <p className="text-sm">
            Email: <a href="mailto:support@ditris.com" className="underline">support@ditris.com</a><br />
            Phone: +1 (555) 123-4567<br />
            Hours: Monday-Friday, 9am-6pm EST
          </p>
        </div>
      </div>
    </div>
  );
};

export default Shipping;